import { ref } from 'vue';
import { CategoryQuery } from '@/services/api/resources/category/query';
import { useTask } from '@/ui/concerns';
import { list } from '@/services/api/resources/category';
import { sequence } from '@/ui/helpers';

export const useCategoryCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const query = (): CategoryQuery => ({
    search: '',
    sort: '',
    dir: '',
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => sequence(
      list(query()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
